export function formatRefundNumber(number: number): string {
    return `REF-${String(number).padStart(4, '0')}`;
}
